import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import PlatformLayout from './pages/platform/PlatformLayout';
import PlatformOverview from './pages/platform/Overview';
import ShopDetailPage from './pages/platform/ShopDetailPage';
import ShopsPage from './pages/platform/ShopsPage';
import StaffPage from './pages/platform/StaffPage';
import InventoryPage from './pages/shop/InventoryPage';
import BillingPage from './pages/shop/BillingPage';
import CurrencyPage from './pages/shop/CurrencyPage';
import ShopLayout from './pages/shop/ShopLayout';
import CategoriesPage from './pages/shop/CategoriesPage';
import CollectionsPage from './pages/shop/CollectionsPage';
import CreateOrderPage from './pages/shop/CreateOrderPage';
import CustomerDetailPage from './pages/shop/CustomerDetailPage';
import CustomersPage from './pages/shop/CustomersPage';
import MembersPage from './pages/shop/MembersPage';
import ProductEditPage from './pages/shop/ProductEditPage';
import ShopOverview from './pages/shop/Overview';
import OrdersPage from './pages/shop/OrdersPage';
import ProductsPage from './pages/shop/ProductsPage';
import SettingsPage from './pages/shop/SettingsPage';
import './styles/dashboard.css';

function TenantRedirect() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/tenant/, '/shop');
  return <Navigate to={`${path}${location.search}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />

        <Route path="/platform" element={<PlatformLayout />}>
          <Route index element={<PlatformOverview />} />
          <Route path="shops" element={<ShopsPage />} />
          <Route path="shops/:shopId" element={<ShopDetailPage />} />
          <Route path="staff" element={<StaffPage />} />
        </Route>

        <Route path="/shop" element={<ShopLayout />}>
          <Route index element={<ShopOverview />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="products/:productId" element={<ProductEditPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="collections" element={<CollectionsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/new" element={<CreateOrderPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:customerId" element={<CustomerDetailPage />} />
          <Route path="members" element={<MembersPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="currency" element={<CurrencyPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="/tenant/*" element={<TenantRedirect />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
